import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-color-code',
  templateUrl: './color-code.component.html',
  styleUrls: ['./color-code.component.scss']
})
export class ColorCodeComponent {
  @Input() isExpansionState: boolean;
}
